module.exports = __webpack_public_path__ + "img/9788958285502.e7b848e1.jpg";